module.exports = "/_next/static/images/af96b20628bdffdbe849ec20aba25ee6-people-smile-at-home-xs@2x.jpg";